/* @flow */
import React, { type Node } from 'react';
import type { TExpertise } from '../../types/helpful';
import type { TCity } from '../../types/city';
import { ArticleImg, ArticleRubric, ArticleTitle, ExpertiseContent, ExpertiseItem } from './styles';
import Link from '../../components/Link';
import { changePreviewImageSize } from '../../utils/links';

type TProps = {
	item: TExpertise,
	city: TCity,
};

const Expertise = ({ item, city }: TProps): Node => {
	const getExpertiseDataByType = (
		type: string,
	): {
		title: string,
		link: string,
	} => {
		switch (type) {
			case 'tenant':
				return {
					title: 'Тайный жилец',
					link: 'tainyi-zhilec',
				};
			case 'analytics':
				return {
					title: 'Исследования',
					link: 'research',
				};
			case 'buyer':
			default:
				return {
					title: 'Тайный покупатель',
					link: 'tainyi-pokupatel',
				};
		}
	};
	const data = getExpertiseDataByType(item.type);

	return (
		<ExpertiseItem>
			<ExpertiseContent>
				{item.previewPicture && (
					<ArticleImg
						as={Link}
						to={`/${city.link}/expert/${data.link}/${item.slug}/`}
						bg={changePreviewImageSize(item.previewPicture, { w: 1000 })}
					/>
				)}
				<ArticleRubric to={`/${city.link}/expert/${data.link}/`}>{data.title}</ArticleRubric>
				<ArticleTitle>
					<Link to={`/${city.link}/expert/${data.link}/${item.slug}/`}>{item.title}</Link>
				</ArticleTitle>
			</ExpertiseContent>
		</ExpertiseItem>
	);
};

export default Expertise;
